// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {sync} from 'vuex-router-sync'
import VueI18n from 'vue-i18n'
// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/main.css'
import '../static/css/color-dark.css'
import '../static/css/m-cover.css'
import AjaxPlugin from '@/plugins/ajax'
import store from './vuex/index'
import common from './mixins/common'
import button from './mixins/button'
import * as MType from './vuex/mutation-types'
import userService from './utils/user'
// 国际化
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import koLocale from 'element-ui/lib/locale/lang/ko'
// utils
import storage from './utils/storage'
import utils from './utils/utils'
import dateUtils from './utils/dateUtils'
import './utils/dateExtend'
import jphUi from './libs/ui'
// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import BasePage from './utils/basePage.js'
Vue.use(VueQuillEditor)

require('es6-promise').polyfill()

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(AjaxPlugin)
Vue.use(storage)
Vue.use(jphUi)
Vue.mixin(button)
Vue.mixin({
  methods: common
})
Vue.mixin({
  methods: utils
})
Vue.mixin({
  methods: dateUtils
})
window.basePage = BasePage

const messages = {
  en: Object.assign(require('./local/en_us').default, enLocale),
  ja: Object.assign(require('./local/ja').default, jaLocale),
  tw: Object.assign(require('./local/zh_tw').default, twLocale),
  zh: Object.assign(require('./local/zh_cn').default, zhLocale),
  ko: Object.assign(require('./local/ko').default, koLocale)
}

let langNow = 'en'
if (window.sessionStorage.getItem('uiLang') && window.sessionStorage.getItem('uiLang') !== 'undefined') {
  langNow = window.sessionStorage.getItem('uiLang')
} else {
  window.sessionStorage.setItem('uiLang', 'zh')
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: langNow, // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
sync(store, router)

let history = window.sessionStorage
// history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)

router.beforeEach((to, from, next) => {
  // 检查进入的页面是否需要登入
  // 检查进to是否需要登入
  const name = 'sys.user.accessToken='
  let ca = document.cookie.split(';')
  let tokens = ''
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(name) === 0) {
      tokens = c.substring(name.length, c.length)
    }
  }
  if (to.meta.isLogin && userService.isLogin() === false && tokens === '') {
    next({path: '/'})
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  store.commit(MType.UPDATE_LOADING, true)
  const toIndex = history.getItem(to.path)
  const fromIndex = history.getItem(from.path)
  // start标题
  if (to.meta && to.meta.title) {
    store.commit(MType.UPDATE_SHOW_TITLE, to.meta.title)
  } else {
    store.commit(MType.UPDATE_SHOW_TITLE, '')
  }
  // end标题

  if (toIndex) {
    if (toIndex > fromIndex || !fromIndex || (toIndex === '0' && fromIndex === '0')) {
      store.commit(MType.UPDATE_DIRECTION, 'forward') // 向前
    } else {
      store.commit(MType.UPDATE_DIRECTION, 'reverse') // 回退
    }
  } else {
    ++historyCount
    history.setItem('count', historyCount)
    to.path !== '/' && history.setItem(to.path, historyCount)
    store.commit(MType.UPDATE_DIRECTION, 'forward')
  }
  if (/\/http/.test(to.path)) {
    console.log('***************' + to.path)
    let url = to.path.split('http')[1]
    window.location.href = `http${url}`
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  store.commit('UPDATE_LOADING', false)
  const token = to.query.accessToken
  if (token) {
    userService.save({accessToken: token}, to.query.uiLang, to.query.newHome)
    const newQuery = {...to.query}
    delete newQuery.accessToken
    delete newQuery.uiLang
    delete newQuery.newHome
    // 创建新的路由对象，移除参数
    router.replace({ ...to, query: newQuery })
  }
})
Vue.http.interceptors.request.use(function (config) {
  config.headers.common['uiLang'] = sessionStorage.getItem('langType')
  config.headers.common['accessToken'] = sessionStorage.getItem('accessToken')
  // document.cookie = 'accessToken' + "=" + accessToken;expires=" + exdate.toGMTString())
  // alert(document.cookie['sys.user.accessToken'])
  let date = new Date()
  config.headers.common['timeZone'] = date.getTimezoneOffset() / 60
//  config.headers.common['supplierId'] = sessionStorage.getItem('supplierId')
//  config.headers.common['distributorId'] = sessionStorage.getItem('distributorId')
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// 响应拦截器
Vue.http.interceptors.response.use(
  response => {
    const res = response.data || {}
    // 检查token状态码
    if (router.currentRoute.path !== '/login' && res && (res === -403 || res.code === -403)) {
      ElementUI.Message.error(i18n.t('newHome.expired'))
      sessionStorage.clear()
      var exp = new Date()
      exp.setTime(exp.getTime() + 1 * 1 * 1 * 1 * 1)
      document.cookie = 'sys.user.accessToken=;expires=' + exp.toGMTString() + ';path=/'
      router.push('/')
    }
    return response
  }
)
/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js